import BaseController from "controllers/backend/base"
import {default as jQuery} from 'jquery';
import applyLocalTimeZone from "servos/applyLocalTimeZone";
import ResultsFilterWidget from "widgets/backend/resultsFilterWidget"

class Controller extends BaseController {
  call() {
    super.call()
    applyLocalTimeZone.call(this)
    bindResultsFilter.call(this)
  }
};

var bindResultsFilter = function() {
  let vehicles = gon.vehicles
  if (vehicles.length > 0) {
    addExistVehicleToList(vehicles)
  }
  let elem = this.root
  this.resultsFilter = new ResultsFilterWidget(elem)
}

var addExistVehicleToList = function(vehicles) {
  const button = document.querySelector("input[id=edit-tender]")
  let listOfVehicle = [];
  var ul = document.createElement('ul')
  vehicles.map((vehicle, index) => {
    listOfVehicle.push(vehicle.id)
    var span = document.createElement('span')
    span.setAttribute('id', listOfVehicle[index])
    span.classList.add('remove-tender-vehicle-list')
    if (button !== null) {
      var remove = document.createTextNode('x')
      span.appendChild(remove)
    }

    var li = document.createElement('p')
    li.classList.add('selected-tender-vehicle-list')
    li.setAttribute('id', listOfVehicle[index])
    var vehicle = document.createTextNode(vehicle.name)
    li.appendChild(span)
    li.appendChild(vehicle)

    ul.appendChild(li)
  });
  document.getElementById("vehicle-list").appendChild(ul);
}


export default Controller;
